/**
 * ESLint 6.0.0 以降での hasOwnProperty の糖衣構文
 *
 * @param o 探索対象のオブジェクト
 * @param k 探索対象の key 名
 * @returns { boolean }
 */
export function hasOwnProperty(o: any, k: string): boolean {
  return !!(o) && Object.prototype.hasOwnProperty.call(o, k)
}
